export const ALGOLIA_DEBUG = false;

export function algoliaLog(...args) {
  if (ALGOLIA_DEBUG) console.log(...args);
}

const defaultConfig = {
  app_id: '',
  api_key: '',
  indices: {
    techTransfer: '',
  },
};

const config = window.algoliaConfig || defaultConfig;

export const algoliaConfig = {
  app_id: config.app_id,
  api_key: config.api_key,
};

export const techTransferConfig = {
  ...algoliaConfig,
  index: config.indices?.techTransfer || '',
};
